import type { ReactNode } from 'react';
import classnames from 'classnames';
import styles from './Separator.module.scss';

export type SeparatorOrientation = 'horizontal' | 'vertical';

const ORIENTATION_CLASSES: Record<SeparatorOrientation, string | undefined> = {
    horizontal: styles.horizontal,
    vertical: styles.vertical,
};

interface SeparatorProps {
    orientation?: SeparatorOrientation;
    className?: string;
    /** Shown centered on the line, e.g. a small ornament or a word. */
    children?: ReactNode;
}

/**
 * A decorative separator that renders a subtle gradient line.
 * Orientation controls the direction of the gradient and line axis.
 * Pass className to apply flex sizing or other layout constraints from the parent.
 */
export function Separator({ orientation = 'horizontal', className, children }: SeparatorProps): JSX.Element {
    return (
        <span
            className={classnames(
                styles.separator,
                ORIENTATION_CLASSES[orientation],
                className,
            )}
            aria-hidden="true"
        >
            {children}
        </span>
    );
}
